import { render } from "./scenePresentation.vue?vue&type=template&id=2b33a7ae"
import script from "./scenePresentation.vue?vue&type=script&lang=js"
export * from "./scenePresentation.vue?vue&type=script&lang=js"

import "./scenePresentation.vue?vue&type=style&index=0&id=2b33a7ae&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__